import React from 'react';
import HeroSection from '../components/Home/HeroSection';
import ExploreSection from '../components/Home/ExploreSection';
import FeaturesSection from '../components/Home/FeaturesSection';

// Home page now only renders page-specific content; shared layout is handled in App.jsx
const Home = () => {
    return (
      <>
        <HeroSection />
        <ExploreSection />
        <FeaturesSection />
      </>
    );
};

export default Home;